__turbopack_context__.v({
  "bannerWrapper": "VideoBannerWithPlayButton-module__-AJT9a__bannerWrapper",
  "playButton": "VideoBannerWithPlayButton-module__-AJT9a__playButton",
  "videoModalContent": "VideoBannerWithPlayButton-module__-AJT9a__videoModalContent",
});
